import React, { FunctionComponent } from 'react';

import { MediaPercentage } from '@savebetter/components';

import { useMediaPercentageProps } from '../hooks/useMediaPercentageProps';

import { MediaProps } from './Media';
import { PageSectionBlok } from './PageSection';
import { Section } from './Section';

type Blok = PageSectionBlok & {
  media: MediaProps[];
};
interface BlogPostPageProps {
  blok: Blok;
}
export const BlogPostImage: FunctionComponent<React.PropsWithChildren<BlogPostPageProps>> = ({ blok }) => {
  const { media, hasPaddingBottom = false, hasPaddingTop = false, hasBackground = false } = blok;
  const { getMediaProps } = useMediaPercentageProps();
  const mediaProps = getMediaProps(media[0]);
  return (
    <Section
      width="md"
      className="pt-default md:py-8 flex flex-col"
      hasPaddingTop={hasPaddingTop}
      hasPaddingBottom={hasPaddingBottom}
      hasBackground={hasBackground}
    >
      {media.length > 0 && <MediaPercentage {...mediaProps} size="full" />}
    </Section>
  );
};
